import { useState } from "react";
import { IoMdArrowDropdownCircle, IoMdArrowDropupCircle  } from "react-icons/io";
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'


import { toolbarActions  } from '../../services/EnumsService';
import ToolbarOptionComponent from '../toolbar/ToolbarOptionComponent';
import ToolbarComponent from "../toolbar/ToolbarComponent";
import { SubtaskModal } from "./SubtaskModal";
import { CategoryData } from "../../pages/Category/CategoryWrapper";
import { subtaskOrderUp, subtaskOrderDown, subtaskStart, subtaskFinish, subtaskCancel, subtaskDelete } from "../../api/subtask.api";
import { showError } from "../../services/toastServices";
import { subtaskStatusEnum } from "../../services/EnumsService";
import ExpandablePanel from "../ExpandablePanel";

export default function ExpandableSubtaskComponent({subtask, isFirst, isLast, expanded, onToggle}) {
    const [showSubtaskModal, setShowSubtaskModal] = useState(false)
    const {category, refreshProjectsCategory} = CategoryData();

    const editSubtaskCloseAction = (()=>{
        setShowSubtaskModal(false)
    })
    const editSubtaskAction = (()=>{
        setShowSubtaskModal(true)
    })

    const changeStatusError = ((error)=>{
        showError(`Error al cambiar el estado de la tarea. ${error.message}`)

    })

    const editSubtaskModal = (<SubtaskModal subtaskId={subtask.id} closeAction={editSubtaskCloseAction}></SubtaskModal>)
    const startSubtaskAction =(async ()=>{
        await subtaskStart(subtask.id, changeStatusError)
        refreshProjectsCategory();
    })

    const finishSubtaskAction =(async ()=>{
        await subtaskFinish(subtask.id, changeStatusError)
        refreshProjectsCategory();
    })

    const cancelSubtaskAction =(async ()=>{
        await subtaskCancel(subtask.id, changeStatusError)
        refreshProjectsCategory();
    })
    const deleteSubtaskAction =(async ()=>{
        await subtaskDelete(subtask.id, changeStatusError)
        refreshProjectsCategory();
    })

    const toolbarIcons = (
        <ToolbarComponent className=''>
            <ToolbarOptionComponent title={'Editar'} size={17} icon={toolbarActions.Edit} clickAction={editSubtaskAction}/>
            <ToolbarOptionComponent title={'Iniciar'} size={17} icon={toolbarActions.Start} clickAction={startSubtaskAction}/>
            <ToolbarOptionComponent title={'Finalizar'} size={17} icon={toolbarActions.Finish} clickAction={finishSubtaskAction}/>
            <ToolbarOptionComponent title={'Cancelar'} size={17} icon={toolbarActions.Cancel} clickAction={cancelSubtaskAction}/>
            <ToolbarOptionComponent title={'Eliminar'} size={17} icon={toolbarActions.Delete} clickAction={deleteSubtaskAction}/>
        </ToolbarComponent>
    );    

    const header = (
        <div key={subtask.id} className="flex flex-col">
            <div className="">
                <div className='text-xl rounded-md px-2' style={{ backgroundColor: `${subtaskStatusEnum(subtask.status).color}`}}>{subtask.name}</div>                
            </div>
        </div>

    )

    return (
        <div>
            {showSubtaskModal && editSubtaskModal}

            <ExpandablePanel key={subtask.id} header={header} toolbarIcons={toolbarIcons} expanded={expanded} onToggle={onToggle}>
                {/* <div className='text-l '>{subtask.description}</div> */}

                    <Markdown 
                    className='border-l-4 pl-2 pr-2 prose max-w-full max-h-60 overflow-y-scroll mb-2'
                    remarkPlugins={[remarkGfm]}
                    >
                        {subtask.description}
                    </Markdown>
                
            </ExpandablePanel>
        </div>
    )
}